import { VueMaskFilter } from 'v-mask';
import MaskList from "@/modules/Mask/MaskList";

export default class MaskUtils {

	static to(value?: string, mask?: string): string {
		return (value && mask)
			? VueMaskFilter(value, mask)
			: (value || '');
	}

	static toPhone(value?: string): string {
		return MaskUtils.to(value, MaskList.phone);
	}

	static toCardNumber(value?: string): string {
		return MaskUtils.to(value, MaskList.cardNumber);
	}

	static toCardFormattedNumber(value?: string): string {
		return MaskUtils.to(value, MaskList.formattedCardNumber);
	}

	static toFormattedAccount(value?: string): string {
		return MaskUtils.to(value, MaskList.formattedAccount);
	}

}